// MiniBars — a dependency-free bar chart using pure CSS/flex.
// Each bar's height is proportional to value/max*100%; 6 columns, green fill.
// Month label displayed below each bar; hover tooltip shows the raw value.

export interface MiniBarsItem {
  label: string;
  value: number;
}

export interface MiniBarsProps {
  data: MiniBarsItem[];
}

export function MiniBars({ data }: MiniBarsProps) {
  if (data.length === 0) return null;

  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="flex h-full min-h-[120px] items-end gap-2">
      {data.map((item, i) => {
        const heightPct = Math.round((item.value / max) * 100);
        return (
          <div
            key={i}
            className="flex flex-1 flex-col items-center gap-1"
            title={`${item.label}: ${item.value}`}
          >
            {/* Bar container — fixed height so bars grow upward from bottom */}
            <div className="flex w-full flex-col justify-end" style={{ height: "100px" }}>
              <div
                className="w-full rounded-t-[4px] bg-green transition-all duration-300"
                style={{ height: `${heightPct}%`, minHeight: heightPct > 0 ? "2px" : "0" }}
              />
            </div>
            {/* Month label */}
            <span className="text-[10.5px] font-medium text-grey-400 truncate w-full text-center">
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
